import { render, staticRenderFns } from "./HomeBanners.vue?vue&type=template&id=2124f795&scoped=true&"
import script from "./HomeBanners.vue?vue&type=script&lang=js&"
export * from "./HomeBanners.vue?vue&type=script&lang=js&"
import style0 from "./HomeBanners.vue?vue&type=style&index=0&id=2124f795&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124f795",
  null
  
)

export default component.exports